// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_3ME","title":"Header_title__8qQXD","side":"Header_side__1H87S"};